import {isBefore, isAfter} from "date-fns";

export function clearObject(obj: Record<string, unknown>) {

  for (const key of Object.keys(obj)) {
    obj[key] = undefined;
  }

}

export const waitFor = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const statusMap = {
  "PUBLISHED": "Julkinen",
  "PRIVATE": "Piilotettu",
};

type TimedContent = {
  activeStart?: string;
  activeEnd?: string;
};

export function formatContentStatus(status: string, item: TimedContent) {
  if (status === "PRIVATE") return "Piilotettu";

  const now = new Date();

  if (item.activeStart) {
    const dateStart = new Date(item.activeStart);
    if (isBefore(now, dateStart)) {
      return "Ajastettu";
    }
  }

  if (item.activeEnd) {
    const dateEnd = new Date(item.activeEnd);
    if (isAfter(now, dateEnd)) {
      return "Ajastus päättynyt";
    }
  }

  return "Julkinen";
};

export type DeferredPromise<T> = {
  resolve: (value: T) => void;
  reject: (reason?: any) => void;
  promise: Promise<T>;
}

export function deferred<T>() {
  let def: any = {};

  def.promise = new Promise<T>((resolve, reject) => {
    def.reject = reject;
    def.resolve = resolve;
  });

  return def as DeferredPromise<T>;
}

export function debounce(ms: number, fn: (...args: any[]) => void) {
  let timeout: any = null;
  return (...args: any[]) => {
    const call = () => fn(...args);
    clearTimeout(timeout);
    timeout = setTimeout(call, ms);
  };
};
